import * as React from "react";
// import { Link } from "gatsby"

import Layout from "../components/layout";
import HeroSection from "../components/OurServices/HeroSection";
import Stevedoring from "../components/OurServices/Stevedoring";
import Seo from "../components/seo";

const OurServices = () => (
  <Layout>
    <Seo title="Our Services" />
    <HeroSection />
    <Stevedoring />
  </Layout>
);

export default OurServices;
